import { CurrentPageAndSection } from "../types/CurrentPageAndSection";
import { EdhQuestionPagesResource } from "../types/EdhQuestionPagesResource";
import { InterviewMetadata } from "../types/InterviewMetadata";
import {
  getOrderedSectionIndex,
  getVisiblePagesCount,
  getVisibleSectionsCount,
} from "../utils";

export const updateMetadataValues = (
  current: CurrentPageAndSection,
  metadata: InterviewMetadata,
  questions: EdhQuestionPagesResource,
) => {
  const updatedMetadata = metadata;

  updatedMetadata.sectionsCount = getVisibleSectionsCount(questions.pages);
  updatedMetadata.pagesCount = getVisiblePagesCount(questions.pages);
  updatedMetadata.orderedSectionIndex = getOrderedSectionIndex(
    current.section.code,
    questions.pages,
  );

  return updatedMetadata;
};
